import { useCallback } from "react";
import axios from "axios";
import { useToast } from "@chakra-ui/react";

const useDownloadPdf = () => {
  const toast = useToast();

  const onDownloadPdf = useCallback(async (file: string, fileName: string) => {
    if (!file) return console.error("No file to download");
    try {
      const response = await axios.get(file, {
        responseType: "blob",
      });
      const blob = new Blob([response.data], { type: "application/pdf" });
      const fileURL = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = fileURL;
      a.download = `${fileName}.pdf`;
      a.click();
    } catch (error) {
      toast({
        position: "top",
        title: "Download failed.",
        description: "Please try again.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  }, []);

  return onDownloadPdf;
};

export default useDownloadPdf;
